import { useEffect, useState } from "react";

import { getConstants } from "services/constantsRegistry/rest";
import { ConstantsDto } from "services/constantsRegistry/restModels";

export interface UseConstantsResult {
    constants: ConstantsDto | null;
    loading: boolean;
    error: boolean;
}

// Константы статичны в пределах сессии — кешируем на уровне модуля, чтобы каждая
// фича не ходила за ними заново. Промис общий, параллельные монтирования не плодят запросы.
let cache: ConstantsDto | null = null;
let inFlight: Promise<ConstantsDto | null> | null = null;

const loadConstants = (): Promise<ConstantsDto | null> => {
    if (cache) return Promise.resolve(cache);

    if (!inFlight) {
        inFlight = getConstants()
            .then((result) => {
                if (result) cache = result;
                return result;
            })
            .finally(() => {
                inFlight = null;
            });
    }

    return inFlight;
};

export const useConstants = (): UseConstantsResult => {
    const [constants, setConstants] = useState<ConstantsDto | null>(cache);
    const [loading, setLoading] = useState<boolean>(!cache);
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if (cache) return;

        // ignore-флаг: ответ после размонтирования не трогает стейт.
        let ignore = false;

        setLoading(true);
        setError(false);

        loadConstants()
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setConstants(result);
                } else {
                    setError(true);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, []);

    return { constants, loading, error };
};
